import $ from "jquery";
import Cookie from "js-cookie";
import { App } from "./app";
import lurl from "./lurl";
const _user_id = Cookie.get("signed_user_id");
// previously the user_id was generated using a user_key - this is being phased out
// now we will just generate a random user_id and store it in a local cookie, however
// there are some logacy clients that will lose their accounts if we do this, so we still
// need to check for it, and pass it through to the init call if it exists
const _user_key = Cookie.get("user_key") || "";
Promise.resolve()
    .then(() => {
    // we are running from file://, probably in the iphone app, so set things
    // up to handle that properly
    if (!document.location.hostname || document.location.port == "8080") {
        $("body").addClass("is-local");
        window._js = null;
    }
    if (!window._js || !window._js.user) {
        // when running embedded the _js object will not be set, and we have
        // to get it via an ajax call
        return $.getJSON(lurl("/?json=1&user_key=" + _user_key))
            .then((data) => {
            window._js = data;
            return data.user.suk;
        })
            .then((signed_user_id) => {
            if (!_user_id && signed_user_id) {
                // this must be the first time logging on - there is no user_id set - we
                // will have got one back from the server, so save it too a cookie
                Cookie.set("signed_user_id", signed_user_id, {
                    path: "/",
                    expires: 3650,
                });
            }
        });
    }
})
    .then(() => {
    if (!Cookie.get("settings.position")) {
        // we dont have a location cookie set - this can happen when running in embedded
        // mode because only local cookies get saved. In this case we will request a random
        // location from the server, and save it to the location position cookie
        return $.getJSON("https://babbl.xyz/position/random.json").then((response) => {
            Cookie.set("settings.position", response, {
                path: "/",
                expires: 365,
            });
        });
    }
})
    .then(() => {
    $(document).ready(() => {
        window._app = window._app || new App(window._js);
    });
});
